import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { JwtService } from "app/generic/JwtService";
import { NewModalService } from "app/generic/new-modal/new-modal.service";
import { environment } from "environments/environment";

@Injectable()
export class ElaborazioniClimaticheService extends JwtService {
  constructor(private http: HttpClient, public router: Router, public modalService: NewModalService) { super(router, modalService); }

  selectAll(): Promise<any> {
    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/documenti/findAllBySezione/4', super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

}
